import type {FC} from 'react';
import clsx from 'clsx';

type Props = {
	checked?: boolean;
	description?: string;
	price?: number;
	label: string;
	name: string;
	value: string;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Checkbox: FC<Props> = ({
	description,
	checked,
	price,
	label,
	name,
	value,
	onChange,
}) => {
	return (
		<label
			className={clsx(
				'flex',
				'items-center',
				'cursor-pointer',
				'rounded-lg',
				'border',
				'px-6',
				'py-4',
				'gap-6',
				'shadow-sm',
				'focus:outline-none',
				'group/field',
				'active:ring-2',
				'active:ring-offset-2',
				'active:ring-primary-dark',
				'focus-within:ring-2',
				'focus-within:ring-offset-2',
				'focus-within:ring-primary-dark',
				checked ? 'bg-primary-dark' : 'bg-white',
			)}
		>
			<input
				name={name}
				type="checkbox"
				value={value}
				onChange={onChange}
				className={clsx('h-4', 'w-4', 'text-gray-400', 'focus:ring-0', 'sr-only')}
			/>
			<div className={clsx('flex', 'justify-between', 'flex-1', 'items-center', 'gap-8')}>
				<div className={clsx('flex', 'flex-col', 'text-sm')}>
					<span className={clsx('font-medium', checked ? 'text-white' : 'text-gray-900')}>
						{label}
					</span>
					{description && (
						<div
							className={clsx(
								'whitespace-pre-line',
								checked ? 'text-gray-400' : 'text-gray-500',
							)}
						>
							{description}
						</div>
					)}
				</div>
				{price && (
					<span
						className={clsx(
							'text-sm',
							'font-medium',
							'text-gray-900',
							'whitespace-nowrap',
							checked && 'text-white',
						)}
					>
						kr {price}
						<span
							className={clsx(
								'ml-1',
								'text-gray-500',
								'sm:ml-0',
								checked && 'text-gray-400',
							)}
						>
							,-
						</span>
					</span>
				)}
			</div>
		</label>
	);
};
